export const GOLFERS = [
  { name: "Bryson DeChambeau" },
  { name: "Tommy Fleetwood" },
  { name: "Scottie Scheffler" },
  { name: "Matt Fitzpatrick" },
  { name: "Ludvig Åberg" },
  { name: "Justin Rose" },
  { name: "Nicolai Højgaard" },
  { name: "Daniel Berger" },
  { name: "Akshay Bhatia" },
  { name: "Jon Rahm" },
  { name: "Cameron Young" },
  { name: "Rory McIlroy" },
  { name: "Hideki Matsuyama" },
  { name: "Xander Schauffele" },
  { name: "Jake Knapp" },
  { name: "Min Woo Lee" },
  { name: "Chris Gotterup" },
  { name: "Collin Morikawa" },
  { name: "Patrick Reed" },
  { name: "Brooks Koepka" },
  { name: "Sepp Straka" },
  { name: "Jacob Bridgeman" },
  { name: "Robert MacIntyre" },
  { name: "Cameron Smith" },
  { name: "Viktor Hovland" },
  { name: "Adam Scott" },
  { name: "Corey Conners" },
];